export enum PaymentType {
	DIRECT_DEBIT = 'BEZ',
	BANK_TRANSFER = 'UEB',
	CREDIT_CARD = 'MCP',
	PAYPAL = 'PPL',
	SOFORT = 'SUB',
}
